import React from 'react';

import { TwitterTweetEmbed } from 'react-twitter-embed';

import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
// import SectionHeader from './partials/SectionHeader';
import {
	FaExclamationTriangle,
	FaPassport,
	FaPoo,
	FaReadme,
} from 'react-icons/fa';
// import Image from '../elements/Image';

import './hero.css';

// typing animation start

let TxtType = function (el, toRotate, period) {
	this.toRotate = toRotate;
	this.el = el;
	this.loopNum = 0;
	this.period = parseInt(period, 10) || 2000;
	this.txt = '';
	this.tick();
	this.isDeleting = false;
};

TxtType.prototype.tick = function () {
	let i = this.loopNum % this.toRotate.length;
	let fullTxt = this.toRotate[i];

	if (this.isDeleting) {
		this.txt = fullTxt.substring(0, this.txt.length - 1);
	} else {
		this.txt = fullTxt.substring(0, this.txt.length + 1);
	}

	this.el.innerHTML = '<span class="wrap">' + this.txt + '</span>';

	let that = this;
	let delta = 200 - Math.random() * 100;

	if (this.isDeleting) {
		delta /= 2;
	}

	if (!this.isDeleting && this.txt === fullTxt) {
		delta = this.period;
		this.isDeleting = true;
	} else if (this.isDeleting && this.txt === '') {
		this.isDeleting = false;
		this.loopNum++;
		delta = 500;
	}

	setTimeout(function () {
		that.tick();
	}, delta);
};

window.onload = function () {
	let elements = document.getElementsByClassName('typewrite');
	for (let i = 0; i < elements.length; i++) {
		let toRotate = elements[i].getAttribute('data-type');
		let period = elements[i].getAttribute('data-period');
		if (toRotate) {
			new TxtType(elements[i], JSON.parse(toRotate), period);
		}
	}
	// INJECT CSS
	let css = document.createElement('style');
	css.type = 'text/css';
	css.innerHTML = '.typewrite > .wrap { border-right: 0.08em solid #fff}';
	document.body.appendChild(css);
};

// typing animation end

const propTypes = {
	...SectionTilesProps.types,
};

const defaultProps = {
	...SectionTilesProps.defaults,
};
const Email = ({
	className,
	topOuterDivider,
	bottomOuterDivider,
	topDivider,
	bottomDivider,
	hasBgColor,
	invertColor,
	pushLeft,
	...props
}) => {
	const outerClasses = classNames(
		'features-tiles section',
		topOuterDivider && 'has-top-divider',
		bottomOuterDivider && 'has-bottom-divider',
		hasBgColor && 'has-bg-color',
		invertColor && 'invert-color',
		className
	);

	const innerClasses = classNames(
		'features-tiles-inner section-inner pt-0',
		topDivider && 'has-top-divider',
		bottomDivider && 'has-bottom-divider'
	);

	const tilesClasses = classNames(
		'tiles-wrap center-content',
		pushLeft && 'push-left'
	);

	// const sectionHeader = {
	// 	title: 'Build up the whole picture',
	// 	paragraph:
	// 		'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum — semper quis lectus nulla at volutpat diam ut venenatis. hello',
	// };

	return (
		<section {...props} className={outerClasses}>
			<div className='container'>
				<div className={innerClasses}>
					{/* <SectionHeader data={sectionHeader} className='center-content' /> */}
					<div class='typewriter' align='left'>
						<p className='center'>
							<h1 class='typewriter'>
								Hello, Hamza{' '}
								<span role='img' aria-label='waving brown hand emoji'>
									👋🏽
								</span>
							</h1>
							<br />
							<br />
							So recently I was lucky enough to acquire hamza.com. After years
							of always searching to see if it was available, it’s pretty cool
							to finally have it! But now that I have it, I don’t want to just
							sit on the domain and do nothing with it.
							<br />
							<br />
							For this reason, I imagined a few ways that I could bring this
							cool feeling to other Hamzas around the world (or at least
							online). The best thing at the moment would be allowing other
							Hamzas to have a <b>custom @hamza.com email</b> for personal use.
							<br />
							<br />
							{/* <h5> */}
							It's completely <b>free</b>, and I plan to keep it this way.
							<br />
							<br />
							{/* </h5> */}I would be using email alias forwarding, so basically
							if your email is <i>hamzathechef@gmail.com</i>, you can choose an
							alias like <i>chef@hamza.com</i> which will act as a secondary
							route to your inbox. By default you'll only <b>receive</b> emails
							with your @hamza.com alias, but you can also <b>send</b> emails if
							your existing email provider is Gmail.
							<br />
							<br />
							There are a few rules before you request a custom alias:
						</p>
						<br />
					</div>
					<div className={tilesClasses}>
						{/* <div className='tiles-item reveal-from-bottom'>
							<div className='tiles-item-inner'>
								<div className='features-tiles-item-header'>
									<div className='features-tiles-item-image mb-16'>
										<Image
											src={require('./../../assets/images/feature-tile-icon-01.svg')}
											alt='Features tile icon 01'
											width={64}
											height={64}
										/>
									</div>
								</div>
								<div className='features-tiles-item-content'>
									<h4 className='mt-0 mb-8'>No spam</h4>
									<p className='m-0 text-sm'>
										Duis aute irure dolor in reprehenderit in voluptate velit
										esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
										occaecat cupidatat.
									</p>
								</div>
							</div>
						</div> */}

						{/* <div
							className='tiles-item reveal-from-bottom'
							data-reveal-delay='200'
						>
							<div className='tiles-item-inner'>
								<div className='features-tiles-item-header'>
									<div className='features-tiles-item-image mb-16'>
										<Image
											src={require('./../../assets/images/feature-tile-icon-02.svg')}
											alt='Features tile icon 02'
											width={64}
											height={64}
										/>
									</div>
								</div>
								<div className='features-tiles-item-content'>
									<h4 className='mt-0 mb-8'>Robust Workflow</h4>
									<p className='m-0 text-sm'>
										Duis aute irure dolor in reprehenderit in voluptate velit
										esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
										occaecat cupidatat.
									</p>
								</div>
							</div>
						</div> */}

						<div
							className='tiles-item reveal-from-bottom'
							data-reveal-delay='400'
						>
							<div className='tiles-item-inner'>
								<div className='features-tiles-item-header'>
									<div className=''>
										<FaPassport
											style={{
												fill: 'white',
												height: '2em',
												width: '2em',
											}}
										/>
									</div>
								</div>
								<div className='features-tiles-item-content'>
									<h4 className='mt-0 mb-8'>
										<br />
										Only Hamzas
									</h4>
									<p className='m-0 text-sm'>
										Your name must be Hamza to have an @hamza.com email alias.
									</p>
								</div>
							</div>
						</div>

						<div className='tiles-item reveal-from-bottom'>
							<div className='tiles-item-inner'>
								<div className='features-tiles-item-header'>
									<div className=''>
										<FaExclamationTriangle
											style={{
												fill: 'white',
												height: '2em',
												width: '2em',
											}}
											cursor='not-allowed'
										/>
									</div>
								</div>
								<div className=''>
									<h4 className='mt-0 mb-8'>
										<br />
										Don't spam
									</h4>
									<p className='m-0 text-sm'>
										Hamzas that use the alias to spam will have their access
										revoked.
									</p>
								</div>
							</div>
						</div>

						<div
							className='tiles-item reveal-from-bottom'
							data-reveal-delay='200'
						>
							<div className='tiles-item-inner'>
								<div className='features-tiles-item-header'>
									<div className=''>
										<FaPoo
											style={{
												fill: 'white',
												height: '2em',
												width: '2em',
											}}
											cursor='not-allowed'
										/>
									</div>
								</div>
								<div className='features-tiles-item-content'>
									<h4 className='mt-0 mb-8'>
										<br />
										Banned names
									</h4>
									<p className='m-0 text-sm'>
										Alias names that include profanity or offensive language
										aren’t allowed.
									</p>
								</div>
							</div>
						</div>

						<div
							className='tiles-item reveal-from-bottom'
							data-reveal-delay='400'
						>
							<div className='tiles-item-inner'>
								<div className='features-tiles-item-header'>
									<div className=''>
										<FaReadme
											style={{
												fill: 'white',
												height: '2em',
												width: '2em',
											}}
										/>
									</div>
								</div>
								<div className='features-tiles-item-content'>
									<h4 className='mt-0 mb-8'>
										<br /> Usage guidelines
									</h4>
									<p className='m-0 text-sm'>
										A @hamza.com email is for personal use. Using it for your
										small-business, resume, portfolio, etc, is fine.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div align='center'>
					<h2>
						<span class='wrap'>
							<span
								class='typewrite'
								data-period='500'
								data-type='[ "chef@hamza.com", "me@hamza.com", "dr@hamza.com", "writer@hamza.com", "hi@hamza.com", "dev@hamza.com", "cpa@hamza.com" ]'
								cursor='pointer'
							/>
						</span>
					</h2>
					<p className='center'>
						<br />
						Request a custom @hamza.com alias using the form below:
						<br />
						<br />
						<TwitterTweetEmbed
							tweetId={'1361811337047912450'}
							options={{ conversation: 'none', theme: 'light' }}
						/>
						<br />
					</p>
				</div>
				<div align='left'>
					<p className='center'>
						Support resources:
						<br />
						•&ensp;{''}
						<a
							href='https://docs.google.com/document/d/1hlJyPSewhUkMvq2DGWZpMZjHubLtwym2GszUn-FAhYY/edit?usp=sharing'
							target='_blank'
							rel='noopener noreferrer'
						>
							Setting up your new @hamza.com email
						</a>
						<br />
						•&ensp;{''}
						<a
							href='https://support.google.com/domains/answer/9437157'
							target='_blank'
							rel='noopener noreferrer'
						>
							Learn how to send emails from an alias in Gmail
						</a>
						<br /> <br />
						The Google form responses are reviewed monthly. In the future, I may
						open hamza.com more to allow subdomains for other Hamzas who might
						want a site, e.g. chef.hamza.com. As of right now though, I’m quite
						busy working on some exciting things.{' '}
						<span role='img' aria-label='Coffee emoji'>
							☕
						</span>{' '}
						<span role='img' aria-label='Hand holding out a cell phone emoji'>
							🤳🏽
						</span>{' '}
						<span role='img' aria-label='Grinning Face With Sweat emoji'>
							😅
						</span>
						<br />
						<br />
						<div class='blobs-container'>
							<div class='blob white'></div>
							<div class='blob yellow'></div>
							<div class='blob orange'></div>
							<div class='blob red'></div>

							<div class='blob blue'></div>

							<div class='blob red'></div>
							<div class='blob orange'></div>
							<div class='blob yellow'></div>
							<div class='blob white'></div>
						</div>
					</p>
				</div>
			</div>
		</section>
	);
};

Email.propTypes = propTypes;
Email.defaultProps = defaultProps;

export default Email;
